//	Internals
import { isEmpty } from "lodash";
//	Externals
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { URL } from "../../../constants/URL";
import {
	useGetGiftsDetails,
	useGetRestaurantSettings,
} from "../../../queryHooks";
import CS from "../../../services/commonService";

import getBadgeClasses from "../../../util/badgeClass";
import { getCurrentTimezoneDate } from "../../../util/columnsOrdering";
import BreadCrumbs from "../../common/breadcrumbs";
// Component starts
const PromoGiftDetails = () => {
	//	Pre-defined values
	const restaurantInfo = {
		restaurantName: "",
		address: "",
		emailId: "",
		photo: "",
	};
	const giftedToUser = {
		phoneNumber: "",
		fullName: "",
		emailId: "",
		photo: "",
	};
	const giftedByUser = {
		phoneNumber: "",
		fullName: "",
		emailId: "",
		photo: "",
	};
	//	Params
	const { slug } = useParams();

	const { data: dataGiftsDetails } = useGetGiftsDetails(slug);

	//  Navigation
	//const navigate = useNavigate();
	//	State values
	const [orderData] = useState({});
	const [restaurantID, setRestaurantID] = useState();
	//	Manipulate the data
	const orderDetails = {
		isTipAdded: false,
		offerApplied: false,
		offerId: "",
		currencyGiftApplied: false,
		currencyGiftId: "",
		orderNumber: "",
		orderType: "",
		orderStatusHist: [],
		items: [],
		subTotal: "",
		tipAmount: "",
		discount: "",
		totalAmount: "",
		tax: "",
		commission: "",
		amountToPayRest: "",
		amountToAdmin: "",
		billSplitStatus: "",
		orderStatus: "",
		sharedBillFriends: false,
		friends: [],
		rewardPointsUsed: false,
		rewardPointsValue: "",
	};

	const {
		restaurantId,
		giftedTo,
		giftedBy,

		paymentDetail,
		orderId = { ...orderDetails },
	} = orderData;

	const {
		isTipAdded = false,
		offerApplied = false,
		offerId,
		currencyGiftApplied = false,
		currencyGiftId,
		walletAmount,

		orderType,

		subTotal,
		tipAmount,
		discount,
		totalAmount,
		amountCustomerPaid,
		tax,
		totalMerchantFee,
		totalCommission,
		amountToPayRest,
		billSplitStatus = false,
		orderStatus,
		sharedBillFriends = false,
		friends = [],
		rewardPointsUsed = false,
		rewardPointsValue,
	} = orderId;

	useEffect(() => {
		setRestaurantID(dataGiftsDetails?.data?.restaurant?.id);
	}, [dataGiftsDetails]);

	if (!isEmpty(restaurantId)) {
		restaurantInfo.phoneNumber =
			isEmpty(restaurantId[0].dialCode) || isEmpty(restaurantId[0].mobile)
				? null
				: `${restaurantId[0].dialCode}-${restaurantId[0].mobile}`;
		restaurantInfo.restaurantName = restaurantId[0].restaurantName;
		restaurantInfo.address = restaurantId[0].address;
		restaurantInfo.emailId = restaurantId[0].emailId;
		restaurantInfo.photo = restaurantId[0].photo;
	}

	if (!isEmpty(giftedTo)) {
		giftedToUser.phoneNumber =
			isEmpty(giftedTo[0].dialCode) || isEmpty(giftedTo[0].mobile)
				? null
				: `${giftedTo[0].dialCode}-${giftedTo[0].mobile}`;
		giftedToUser.fullName = giftedTo[0].firstname + giftedTo[0].lastname;
		giftedToUser.emailId = giftedTo[0].emailId;
		giftedToUser.photo = giftedTo[0].photo;
	}

	if (!isEmpty(giftedBy)) {
		giftedByUser.phoneNumber =
			isEmpty(giftedBy[0].dialCode) || isEmpty(giftedBy[0].mobile)
				? null
				: `${giftedBy[0].dialCode}-${giftedBy[0].mobile}`;
		giftedByUser.fullName = giftedBy[0].firstname + " " + giftedBy[0].lastname;
		giftedByUser.emailId = giftedBy[0].emailId;
		giftedByUser.photo = giftedBy[0].photo;
	}

	return (
		<>
			<BreadCrumbs
				title="View Promo Gift"
				data={[
					{ label: "Promo Gifts", path: URL.promoGifts },
					{ label: "View Promo Gift" },
				]}
			/>
			<div className="content-wrapper order-details-wrap">
				<div className="d-flex justify-content-end w-100 mb-4">
					<p className={getBadgeClasses(orderStatus)}>{orderStatus}</p>
				</div>
				<div className="card p-0">
					<div className="card-body">
						<div className="form-group row">
							<div className="col-md-6">
								<div className="card-box">
									<div className="card-items">
										<h6>Order Information</h6>
										<p>
											ID : <strong>{dataGiftsDetails?.data?.gift_id}</strong>
										</p>
										<p>
											Date :{" "}
											<strong>
												{getCurrentTimezoneDate(
													dataGiftsDetails?.data?.created_at || "-"
												)}
											</strong>
										</p>
										<p>
											Gift Type :{" "}
											<strong>
												{dataGiftsDetails?.data?.gift_type ===
												"RESTAURANT_PROMO_GIFT"
													? "RESTAURANT PROMO GIFT"
													: ""}
											</strong>
										</p>
									</div>
									{paymentDetail && (
										<div className="card-items">
											<h6>Payment Method</h6>
											<p>
												{paymentDetail.card.brand} ....
												{paymentDetail.card.last4}
											</p>
											<p>
												Exp :{" "}
												<strong>
													{paymentDetail.card.exp_month}/
													{paymentDetail.card.exp_year}
												</strong>
											</p>
										</div>
									)}
									<div className="card-items">
										<h6>Restaurant Info</h6>
										<div className="profile-info">
											<div className="personal-info">
												<p>
													<Link
														to={`${URL.restaurants}/${dataGiftsDetails?.data?.restaurant?.id}`}
													>
														<strong>
															{dataGiftsDetails?.data?.restaurant?.name}
														</strong>
													</Link>
												</p>
												<p>
													{dataGiftsDetails?.data?.restaurant?.address_city}
													{","}
													{dataGiftsDetails?.data?.restaurant?.address_country}
													{","}
												</p>
												<p>{dataGiftsDetails?.data?.restaurant?.mobile}</p>
												<p>{dataGiftsDetails?.data?.restaurant?.email}</p>
											</div>
											<div className="user-item">
												<Link
													to={`${URL.restaurants}/${dataGiftsDetails?.data?.restaurant?.id}`}
												>
													{CS.renderImageUrl(
														dataGiftsDetails?.data?.restaurant
															?.profile_image_url
													)}
												</Link>
											</div>
										</div>
									</div>
									<div className="card-items">
										<h6>Gifted To</h6>
										<div className="profile-info">
											<div className="personal-info">
												<p>
													<Link
														to={`${URL.onboarderedUsers}/${dataGiftsDetails?.data?.recipient?.id}`}
													>
														<strong>
															{dataGiftsDetails?.data?.recipient?.first_name}
														</strong>{" "}
														<strong>
															{dataGiftsDetails?.data?.recipient?.last_name}
														</strong>
													</Link>
												</p>
												<p>{dataGiftsDetails?.data?.recipient?.mobile}</p>
												<p>{dataGiftsDetails?.data?.recipient?.email}</p>
											</div>
											<div className="user-item">
												<Link
													to={`${URL.onboarderedUsers}/${dataGiftsDetails?.data?.recipient?.id}`}
												>
													{CS.renderImageUrl(
														dataGiftsDetails?.data?.recipient?.profile_image_url
													)}
												</Link>
											</div>
										</div>
									</div>
									<div className="card-items">
										<h6>Order</h6>
										<ul className="list-group">
											{dataGiftsDetails?.data?.menu_items.map((item, i) => {
												return (
													<li key={i}>
														<p>
															{item?.quantity} x {item?.name} (${" "}
															{item?.price_per_item})
														</p>
														<span>$ {item?.total_price}</span>

														{!isEmpty(item.add_ons) && item.add_ons && (
															<>
																<ul className="list-group">
																	{item.add_ons.map((attribute) => (
																		<>
																			<li>
																				<p>
																					{attribute?.quantity} x{" "}
																					{attribute?.name} (${" "}
																					{attribute.price_per_item})
																				</p>
																				<span>$ {attribute.total_price}</span>
																			</li>
																		</>
																	))}
																</ul>
															</>
														)}
													</li>
												);
											})}
										</ul>

										{/* <div className="d-flex justify-content-between mt-3">
											<h6 className="">Order Total: </h6>
											<span>
												<strong>
													$ {dataGiftsDetailsOrders?.data?.net_amount}
												</strong>
											</span>
										</div> */}
									</div>
								</div>
							</div>
							<div className="col-md-6 col-lg-6">
								<div className="card-box">
									{!isEmpty(dataGiftsDetails?.data?.status_history) && (
										<div className="card-items">
											<h6>Status History</h6>
											<ul className="history-list">
												{dataGiftsDetails?.data?.status_history.map((order) => (
													<>
														<li>
															<div className="history-heading">
																<span>{order.value}</span>
																{/* <p>Status by : {"-"}</p> */}
															</div>
															<div className="history-date">
																<span>
																	{getCurrentTimezoneDate(order?.created_at)}
																</span>
															</div>
														</li>
													</>
												))}
											</ul>
										</div>
									)}

									{currencyGiftApplied && (
										<div className="card-items">
											<h6>Gift currency code</h6>
											<p>
												Code: <strong>{currencyGiftId.giftCode}</strong>
											</p>
											<p>
												Amount: <strong>$ {currencyGiftId.giftAmount}</strong>
											</p>
										</div>
									)}
									{!isEmpty(friends) && friends.length !== 0 && (
										<div className="card-items">
											<h6>Friends</h6>
											{friends.map((friend) => (
												<>
													<div className="d-flex align-items-center">
														<div className="flex-auto">
															{CS.renderImageUrl(friend.photo)}
														</div>
														<div className="d-flex flex-column">
															<span className="pl-2 user-head">
																{friend.firstname} {friend.lastname}
															</span>
															<span className="pl-2">{friend.emailId}</span>
														</div>
													</div>
												</>
											))}
										</div>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default PromoGiftDetails;
